// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx

// TODO: Check if the icon is alined properly.
// If it is not: Replace/extend defaultAlignedActionIconGroupProps to make it look right.
// https://stash.int.klarna.net/projects/UI/repos/bubble-ui/pull-requests/121/overview?commentId=2244923
import baseIcon, { defaultAlignedActionIconGroupProps } from '@bubble-ui/temp-icon-base';
var ActionIconPlaceholderPath = 'M9.149 8.438 7.252 5.975l1.877-2.436c.537.68.87 1.529.87 2.46 0 .923-.325 1.762-.85 2.439ZM4.408 9.667l1.58-2.053 1.589 2.06a3.972 3.972 0 0 1-3.169-.007ZM2.86 3.55l1.868 2.424L2.84 8.424A3.957 3.957 0 0 1 2 6c0-.926.33-1.769.86-2.449Zm4.688-1.238-1.56 2.023L4.437 2.32A3.978 3.978 0 0 1 6 2.001a3.97 3.97 0 0 1 1.548.312ZM6 0C2.69 0 0 2.692 0 6a6.007 6.007 0 0 0 6 6c3.309 0 6-2.691 6-6 0-3.308-2.691-6-6-6Z';
var ActionIconPlaceholder = baseIcon('ActionIconPlaceholder', {
  groupProps: defaultAlignedActionIconGroupProps,
  getPath: () => ActionIconPlaceholderPath
});
export default ActionIconPlaceholder;
//# sourceMappingURL=index.js.map